import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className }) {
    return (
        <label className={`ns-checkbox ns-sidebar-filter-locate ns-color-black ${className}`}>            
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark" />
            {value}
        </label>
    )
}